<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="hierarchy">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 人员管理
        </span>
        <div class="w_normalNav">
          <button class="OrangeSmBtn" @click="toAddNew">新增</button>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <el-table :data="tableData1" class="stripeTable" style="width: 100%" ref="selectPerson">
            <el-table-column align="center" label="姓名" prop="name"></el-table-column>
            <el-table-column align="center" label="部门" prop="counts"></el-table-column>
            <el-table-column align="center" label="账号" prop="account"></el-table-column>
            <el-table-column label="操作" width="350" align="center">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont icondelete"
                  type="text"
                  size="small"
                  @click="deletePer(scope.$index, scope.row)"
                >删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- dialog -->
        <el-dialog
          class="perEditDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <div class="searchForm1">
            <searchForm :items="items" :formPlus="form_xjyazd" ref="searchForm_xjyazd">
              <template slot="last">
                <el-form-item label="姓名：" prop="name">
                  <el-input v-model="name"></el-input>
                </el-form-item>
                <el-form-item label="选择部门:" prop="dept_id">
                  <searchCompany :pId="company" v-if="initpersonnel" @changeCompany="changeCompany" ref="searchCompany"></searchCompany>
                </el-form-item>
              </template>
            </searchForm>
            <button class="BlueSmBtn searchBut" @click="subSeefrom">搜索</button>
          </div>
          <el-table
            :data="tableData"
            class="stripeTable"
            style="width: 100%"
            ref="allPersonnel"
            @selection-change="handleSelectionChange"
          >
            <el-table-column :selectable="isDisabled" type="selection" width="60" align="center"></el-table-column>
            <el-table-column align="center" label="姓名" prop="name"></el-table-column>
            <el-table-column align="center" label="部门" prop="deptName"></el-table-column>
            <el-table-column align="center" label="账号" prop="userAccount"></el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入层级名称", trigger: "blur" }],
        remark: [
          { max: 150, message: "层级描述不可多于150字", trigger: "blur" }
        ]
      },
      initpersonnel: false,
      //禁用\默认选中
      Row: [],
      tabName: "hierarchy",
      loading: true,
      form_jsgl: {},
      displayForm: false,
      loadingStatus: false,
      showTable: true,
      other: {},
      other1: {},
      //弹框标题
      title: "",
      //弹框搜索
      items: [],
      form_xjyazd: {},
      status: "",
      addEquipment: {
        name: "",
        remark: "",
        people: ""
      },
      edit_id: "",
      bLoading: true,
      tableData: [],
      tableData1: [],
      selects: [],
      selects_id: [],
      //搜索
      company: "",
      name: "",
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "姓名"
        },
        {
          prop: "counts",
          label: "部门"
        },
        {
          prop: "account",
          label: "账号"
        }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    searchCompany: () => import("public/searchCompany")
  },
  methods: {
    //禁用
    isDisabled(row, index) {
      if (this.tableData1.find(element => element.user_id === row.id)) {
        return false;
      } else {
        return true;
      }
    },
    //初始化列表
    initTable() {
      this.$axiosget("operation/management/findUser", {
        params: {
          id: this.$route.params.id
        }
      }).then(res => {
        this.tableData1 = res.data.data;
      });
    },
    //按部门搜索
    changeCompany(dept_id) {
      this.company = dept_id;
    },
    //搜索
    subSeefrom() {
      // var formData = new FormData();
      // formData.append("name",this.name);
      // formData.append("company",this.company);
      this.$axiosget("operation/empApi/findUser", {
        params: {
          name: this.name,
          dept_id: this.company
        }
      }).then(res => {
        this.tableData = res.data.data;
      })
    },
    //选中的人员
    handleSelectionChange(val) {
      this.selects = val;
    },
    //新增
    toAddNew() {
      this.initpersonnel = true;
      this.status = 1;
      this.title = "新增人员";
      this.displayForm = true;
      this.name = "";
      this.company = undefined;
      this.Row = [];
      this.$axiosget("operation/empApi/findUser").then(res => {
        this.tableData = res.data.data;
        //console.log(this.tableData1,"tableData1")
        this.tableData1.forEach(element => {
          this.tableData.forEach(ele => {
            if(element.user_id === ele.id) {
              this.Row.push(ele);
              //console.log(this.Row,"Row")
            }
          })
        })
        this.toggleSelection(this.Row);
      });
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
        this.$refs['searchCompany'].company = "";
    },
    //默认选中
    toggleSelection(rows) {
      this.$nextTick(() => {
        rows.forEach(row => {
          // toggleRowSelection  这个方法是用来选中某一行（打勾）
          // row 是要选中的那一行
          // true 是为选中
          this.$refs.allPersonnel.toggleRowSelection(row, true);
        });
      });
    },
    //保存
    submitForm() {
      //console.log(this.selects, "选中的人员");
      this.selects_id = [];
      let selectPerson = this.selects;
      // if(this.tableData1.find(it => it.id ===))
      this.selects.find(element => {
          this.selects_id.push(element.id);
        if(this.tableData1.find(it => element.id === it.user_id)) {
          this.selects_id.splice(this.selects_id.indexOf(element.id),1);
        }
      });
      let list = this.selects_id.join(",");
      //console.log(list, "list");

      var formData = new FormData();
      formData.append("id", this.$route.params.id);
      formData.append("list", list);
      this.$axiospost("operation/management/relate", formData).then(res => {
        this.$message.success("新增成功！");
        this.initTable();
        this.displayForm = false;
      });
    },
    //删除
    deletePer(index, row) {
      this.$confirm("是否删除该人员？", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axiosdelete("operation/management/deleteRelate", {
          params: {
            id: row.id
          }
        }).then(res => {
          this.$message.success("删除成功!");
          this.initTable();
          this.selects_id = [];
        });
      });
    }
  },
  created() {
    this.initTable();
  }
};
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-textarea__inner {
  border: 1px solid #3d4963;
  border-radius: 0;
  width: 310px;
  background: transparent;
  color: #cacaca;
}
.perEditDialog {
  .searchForm1 {
    padding: 0;
    .el-form-item__label {
      width: 90px;
    }
    .searchBut {
      margin-left: 320px;
      margin-bottom: 10px;
    }
  }
  .el-dialog__title {
    border-bottom: 2px solid #35b9f7;
    font-size: 16px;
    display: inline-block;
    height: 52px;
    line-height: 52px;
    position: relative;
    top: -20px;
  }
  .el-form-item {
    width: 310px;
    margin-right: 20px;
  }
  .el-input__inner {
    display: inline-block;
    flex: 1;
    background: #2e3657;
    color: #fff;
    height: 33px;
    line-height: 33px;
  }
  .el-input.is-focus .el-input__inner {
    border: 1px solid #3587c7;
  }
  .stripeTable {
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      background-color: #409EFF;
      border-color: #409EFF;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/mission/personnel.vue